import React from "react";
import "./MandateNotice.scss";

const MandateNotice: React.FC = () => (
  <div className="mandate-notice">
    <p>
      By completing this registration you authorize Eager Dog to attempt to
      charge the payment method on file if one or more of your entries are
      approved off the waitlist. If the charge is unsuccessful, you will
      receive a payment link via email to complete your payment manually.
    </p>
  </div>
);

export default MandateNotice;
